module.exports = __webpack_public_path__ + "img/9788994343709.6a94e5bc.jpg";